module.exports = __webpack_public_path__ + "static/media/icon-outline-bolt-blue.b5a76822.svg";